module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbfa779a3c18dde6e20dce37d73e6ddee.bfa779a3.png";